<script setup lang="ts">
import Toast from "primevue/toast";
</script>

<template>
  <Toast />
</template>
